import React, { useMemo, useState, useEffect } from "react";
import { useTranslation } from 'react-i18next';
import {
  View,
  Text,
  TextInput,
  TouchableOpacity,
  Modal,
  StyleSheet,
  Platform,
  Image
} from "react-native";
// import DateTimePicker from "@react-native-community/datetimepicker";
import IdCard from "../../../../../../../../assets/images/id-card.png";
import { useSessionStore } from "../../../../../../../state/src/useSessionStore";
import type { SessionState } from "../../../../../../../state/src/useSessionStore";
import identificationsData from "../../../../../constants/identifications.json";
import Colors from "../../../../../constants/colors";
import { ComponentStyles } from "../../../../../constants/componentStyles";
import  FloatingTextInputComponent from "../../../common/FloatingTextInputComponent";
// import { Ionicons } from "@expo/vector-icons";

type Props = {
  onValidationChange?: (isValid: boolean) => void;
};

const SenderIdentificationNumber: React.FC = ({ onValidationChange }: Props) => {
  const { t, i18n } = useTranslation();
  const [idNumber, setIdNumber] = useState("");
  const selectedIdTypeKey = useSessionStore((s: SessionState) => (s as any).selectedIdTypeKey);
  const selectedIdTypeLabel = useSessionStore((s: SessionState) => (s as any).selectedIdTypeLabel);
  const setSenderPhotoIdNumber = useSessionStore((s: SessionState) => (s as any).setSenderPhotoIdNumber);

  const placeholderText = useMemo(() => {
    const baseLabel = selectedIdTypeLabel || (i18n.language === 'es' ? t('US_DRIVERS_LICENSE_NUMBER') : t('US_DRIVERS_LICENSE_NUMBER'));
    const suffix = i18n.language === 'es' ? 'Número' : 'Number';
    return `${baseLabel} ${suffix}`;
  }, [selectedIdTypeLabel, i18n.language, t]);

  const isValid = idNumber != "" ;
      
  useEffect(() => {
    if (onValidationChange) {
      onValidationChange(isValid);
    }
  }, [isValid, onValidationChange]);



  const handleManualInput = async (text: string) => {
    setIdNumber(text);
    try { setSenderPhotoIdNumber?.(text); } catch {}
  };

  const formatDate = (date: Date) => {
    const mm = String(date.getMonth() + 1).padStart(2, "0");
    const dd = String(date.getDate()).padStart(2, "0");
    const yyyy = date.getFullYear();
    return `${mm}/${dd}/${yyyy}`;
  };

  return (
    <View style={styles.container}>
      <Text style={styles.title}>
        {t("SENDER_IDENTIFICATION_NUMBER")}
      </Text>
      <Text style={styles.subtitle}>{t("PROVIDE_YOUR_PHOTO_ID_NUMBER")}</Text>
      <FloatingTextInputComponent
        isAutoFocus={true}
        label={placeholderText}
        value={idNumber}
        onChangeText={handleManualInput}
      />
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    paddingHorizontal: 24,
    backgroundColor: Colors.white,
    paddingBottom: 200
  },
  title: {
    fontFamily: ComponentStyles.textFamily,
    fontSize: ComponentStyles.titleFont,
    fontWeight: '500', 
    color: Colors.titleTextColor,
    lineHeight: 34,
    marginBottom: 8,
    paddingRight: 100
  },
  subtitle: {
    fontFamily: ComponentStyles.textFamily,
    fontSize: ComponentStyles.subTitleFont,
    fontWeight: '400',
    lineHeight: 24,
    color: Colors.subTitleColor,
    marginBottom: 32
  },
  inputWrapper: {
    flexDirection: "row",
    alignItems: "center",
    backgroundColor: "#f5f5f5",
    borderRadius: 8,
    paddingHorizontal: 16,
    paddingVertical: 12,
    marginBottom: 400
  },
  input: {
    fontFamily: 'Rubik',
    fontSize: 16,
    fontWeight: "400",
    lineHeight: 24,
    color: Colors.subTitleColor,
  },
  modalOverlay: {
    flex: 1,
    justifyContent: "flex-end",
    backgroundColor: "rgba(0,0,0,0.4)",
  },
  bottomSheet: {
    backgroundColor: "#fff",
    padding: 20,
    borderTopLeftRadius: 16,
    borderTopRightRadius: 16,
  },
  modalTitle: { fontSize: 18, fontWeight: "700", marginBottom: 10 },
  modalText: { fontSize: 15, color: "#555" },
  modalDOB: {
    fontSize: 18,
    fontWeight: "600",
    marginTop: 10,
    marginBottom: 20,
    textAlign: "center",
  },
  confirmBtn: {
    backgroundColor: "#000",
    padding: 14,
    borderRadius: 8,
    alignItems: "center",
  },
  confirmText: { color: "#fff", fontWeight: "600", fontSize: 16 },
  cancelBtn: { marginTop: 10, alignItems: "center" },
  cancelText: { fontSize: 15, color: "#666" },
});

export default SenderIdentificationNumber;